import { getHighlightedProductsForSkuCategory } from './highlightedProductUtils';
import { isValidApiName } from './typeguards';
export const getHighlightsForSkuCategoryName = skuCategoryName => {
  if (!skuCategoryName) {
    return [];
  }
  const {
    freeHighlightedProduct,
    paidHighlightedProducts
  } = getHighlightedProductsForSkuCategory({
    skuCategoryName
  });
  return [...(freeHighlightedProduct ? [freeHighlightedProduct] : []), ...(paidHighlightedProducts || [])].filter(isValidApiName);
};
export const pinKeyFeatures = (features, identifier, PinnedFeaturesConfig) => {
  const pinnedFeatures = PinnedFeaturesConfig[identifier];
  if (!pinnedFeatures) return features;
  const pinnedFeaturesSet = new Set(pinnedFeatures);
  const pinned = [];
  const remaining = [];
  features.forEach(feature => {
    if (pinnedFeaturesSet.has(feature.shortName)) {
      pinned.push(feature);
    } else {
      remaining.push(feature);
    }
  });
  pinned.sort((a, b) => pinnedFeatures.indexOf(a.shortName) - pinnedFeatures.indexOf(b.shortName));
  return [...pinned, ...remaining];
};